import React from 'react';
import styled, { keyframes, css } from 'styled-components';

const ANIMATION_LOADING = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LdsRing = styled.div`
  display: flex;
  flex-direction: row;

  align-items: flex-start;

  justify-content: center;

  transform: translate3D(0, 0, 0);
  ${(props) => (props.inline ? inline(props) : absolute)};

  right: 32px;
  top: -6px;
`;

const inline = (props) => css`
  position: relative;
  left: ${(props) => (props.large ? '-16px' : '0px')};
  padding-bottom: ${(props) => (props.large ? '54px' : '16px')};
`;

const absolute = css`
  position: absolute;
  right: -24px;
  top: -4px;
`;

export const LoadingContain = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

const LdsRingInner = styled.div`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width:  ${props => props.size}px;
  height:  ${props => props.size}px;
  margin: 6px;
  border-width: 2.5px;
  border-style: solid;
  border-radius: 50%;
  will-change: transform, border-color;
  animation-delay: ${(props) => props.delay || '0s'};
  animation: ${ANIMATION_LOADING} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${(props) =>
    props.color || props.theme.brandColor} transparent transparent transparent;
`;

LdsRingInner.defaultProps = {
  size: 40
};

const Container = styled.div`
  display: flex;
  position: relative;
  height: ${props => props.size}px;
  width:  ${props => props.size}px;
  margin-right: 8px;

  ${(props) =>
    props.buttonLabel &&
    `
    position: absolute !important;
    top: calc(0px - 20px);
    left: calc(50% - 20px);
    transform: scale(0.8, 0.8);
  `}
`;

Container.defaultProps = {
  size: 40
};

export const LoadingSpinner = ({ buttonLabel, size, inline, top, left, large, color }) => {
  return (
    <Container size={size} buttonLabel={buttonLabel}>
      <LdsRing top={top} left={left} size={size} large={large} inline={inline}>
        <LdsRingInner color={color} size={size} large={large} />
        <LdsRingInner color={color} size={size} large={large} delay={'-0.45s'} />
        <LdsRingInner color={color} size={size} large={large} delay={'-0.3s'} />
        <LdsRingInner color={color} size={size} large={large} delay={'-0.15s'} />
      </LdsRing>
    </Container>
  );
};

export default LoadingSpinner;
